export let SIZES = /*#__PURE__*/function (SIZES) {
  SIZES["EXTRASMALL"] = "extraSmall";
  SIZES["SMALL"] = "small";
  SIZES["NORMAL"] = "normal";
  SIZES["LARGE"] = "large";
  SIZES["EXTRALARGE"] = "extraLarge";
  return SIZES;
}({});
export const CLOSE_BUTTON_DATA_TEST = "ModalCloseButton";